import React from "react";
import { useLocation } from "react-router-dom";

import { useGetCartStripeSessionQuery } from "../cart/piosolverStoreApi";
import { CenteredSpinner } from "../../utils/spinner";

import {
  Header,
  ResultProcessingHeader,
  ResultSuccessDetails,
  ResultSuccessHeader,
  type StripeProductName
} from "./payment-success";
export default function StripePaymentResult() {
  const location = useLocation();
  const sessionId = new URLSearchParams(location.search).get("session_id");
  const { data, error, isLoading } = useGetCartStripeSessionQuery({
    sessionId: sessionId || ""
  });

  if (isLoading)
    return (
      <div className="pb-4">
        <Header />
        <ResultProcessingHeader />
        <CenteredSpinner />
      </div>
    );
  if (error) return <div>Could not get checkout details</div>;

  const productName = (data?.successDetails.productVersion ||
    "PioSOLVER") as StripeProductName;
  const customerEmail = data?.successDetails.email;

  return (
    <div className="pb-4">
      <Header />
      <ResultSuccessHeader productName={productName} />
      <ResultSuccessDetails
        customerEmail={customerEmail}
        productName={productName}
      />
    </div>
  );
}
